<template>
    <div class="cont-tit">
        <h2 class="page-title">Corporate Capabilities</h2>
        <p class="page-desc">
            We, Osang Technology, have a variety of O2O service references based on strong corporate capabilities accumulated through many years of experience.
            We provide customized solutions tailored to customer needs and provide stable and reliable services with high security standards.
            We will support our customers’ successful businesses through constant innovation and differentiation.
        </p>
    </div>
    <div class="capabilities swiper01">
        <div class="capabilities__top">
            <h3 class="capabilities__tit">B2B/B2C/O2O system <br> development reference <span>(recent 3 years)</span></h3>
            <div class="capabilities__btn-wrap">
                <button type="button" class="capabilities__btn prev"></button>
                <button type="button" class="capabilities__btn next"></button>
            </div>
        </div>
        <div class="capabilities__slide">
            <swiper ref="swiperRef" :breakpoints="{
            768: {
                slidesPerView: 3,
                spaceBetween: 20
            },
        }" :spaceBetween="64" :navigation="{
            prevEl: '.swiper01 .prev', 
            nextEl: '.swiper01 .next' 
        }" :modules="modules" class="capabilities-swiper">
                <swiper-slide>
                    <div class="slide">
                        <div class="date">2024</div>
                        <h4 class="tit">True Golf Co., Ltd.</h4>
                        <p class="desc">Establishment of OSE_O2O based on True Golf Hybrid App</p>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide">
                        <div class="date">2023</div>
                        <h4 class="tit">Petarium Co., Ltd</h4>
                        <p class="desc">OSE_O2O Platform Construction (Mall Service and Merchant System) OSE_O2O Platform Ver 1.2Engine Construction</p>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide">
                        <div class="date">2022</div>
                        <h4 class="tit">True Golf Co., Ltd.</h4>
                        <p class="desc">Auto& Co., Ltd.(e-commerce)</p>
                    </div>
                    <div class="slide">
                        <h4 class="tit">Construction of Auto& Co., Ltd.'s shopping mall and improvement of ONC (Affiliate Center</h4>
                    </div>
                    <div class="slide">
                        <h4 class="tit">Auto& Co., Ltd.</h4>
                        <p class="desc">Auto& O2O platform system development</p>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide">
                        <div class="date">2021</div>
                        <h4 class="tit">Hyundai/Kia Members’ Mall</h4>
                        <p class="desc">Hyundai/Kia Members’ Mall Improvements</p>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide">
                        <div class="date">2020</div>
                        <h4 class="tit">Hyundai Genesis</h4>
                        <p class="desc">Genesis App construction and Genesis Member Small Mall O2O transfer</p>
                    </div>
                    <div class="slide">
                        <h4 class="tit">Establishment of Hyundai Shop Digital Key</h4>
                        <p class="desc">O2O business trip system and connection to Hyundai Digital Key system</p>
                    </div>
                    <div class="slide">
                        <h4 class="tit">Kia Red Members</h4>
                        <p class="desc">O2O platform advancement tailored to KIAVIK 2.0” and O2O platform speed improvement, integration and maintenance</p>
                    </div>
                    <div class="slide">
                        <h4 class="tit">Auto& Co., Ltd.</h4>
                        <p class="desc">ISMS certification consulting and security development project</p>
                    </div>
                </swiper-slide>

            </swiper>
        </div>
    </div>

    <div class="capabilities swiper02">
        <div class="capabilities__top">
            <h3 class="capabilities__tit">Medical informatization construction <br>
                project reference <span>(recent 3 years)</span></h3>
            <div class="capabilities__btn-wrap">
                <button type="button" class="capabilities__btn prev"></button>
                <button type="button" class="capabilities__btn next"></button>
            </div>
        </div>
        <div class="capabilities__slide">
            <swiper ref="swiperRef" :breakpoints="{
            768: {
                slidesPerView: 3,
                spaceBetween: 20
            },
        }" :spaceBetween="64" :navigation="{
                prevEl: '.swiper02 .prev', 
                nextEl: '.swiper02 .next' 
            }" :modules="modules" class="capabilities-swiper ">
                <swiper-slide>
                    <div class="slide">
                        <div class="date">2024</div>
                        <h4 class="tit">Ewha Womans University Medical Center</h4>
                        <p class="desc">Ewha Cerebral Vascular Hospital, Ewha Womans University Aortic Vascular Hospital, multilingual portal construction</p>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide">
                        <div class="date">2023</div>
                        <h4 class="tit">Korea University Medical Center</h4>
                        <p class="desc">platform marketing functions and responsive development</p>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide">
                        <div class="date">2022</div>
                        <h4 class="tit">Korea University Medical Center</h4>
                        <p class="desc">Korea University Medical Center Portal Renewal Project</p>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide">
                        <div class="date">2021</div>
                        <h4 class="tit">Catholic Central Medical Center</h4>
                        <p class="desc">Information Convergence Promotion Center system development</p>
                    </div>
                    <div class="slide">
                        <h4 class="tit">Seoul St. Mary's Hospital</h4>
                        <p class="desc">Seoul St. Mary's Hospital Cardiocerebrovascular Portal Construction</p>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide">
                        <div class="date">2020</div>
                        <h4 class="tit">Kyunghee University Medical Center</h4>
                        <p class="desc">Kyunghee University Medical Center portal integrated reorganization and maintenance</p>
                    </div>
                    <div class="slide">
                        <h4 class="tit">Seoul St. Mary's Hospital</h4>
                        <p class="desc">Seoul St. Mary's Hospital Lifelong Health Promotion Center Portal Reconstruction</p>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>


    <div class="capabilities swiper03">
        <div class="capabilities__top">
            <h3 class="capabilities__tit">R&D <br>
                project reference <span>(recent 3 years)</span></h3>
            <div class="capabilities__btn-wrap">
                <button type="button" class="capabilities__btn prev"></button>
                <button type="button" class="capabilities__btn next"></button>
            </div>
        </div>
        <div class="capabilities__slide">
            <swiper ref="swiperRef" :breakpoints="{
            768: {
                slidesPerView: 3,
                spaceBetween: 20
            },
        }" :spaceBetween="64" :navigation="{
                    prevEl: '.swiper03 .prev', 
                    nextEl: '.swiper03 .next' 
                }" :modules="modules" class="capabilities-swiper ">
                <swiper-slide>
                    <div class="slide">
                        <div class="date">2024</div>
                        <h4 class="tit">National IT Industry Promotion Agency</h4>
                        <p class="desc">2024 XaaS Leading Project Project
                            To promote digital service in all industries, discover and spread XaaS leading projects through cooperation between demand (existing industry) and supply (SW industry) companies.</p>
                    </div>
                    <div class="slide">
                        <h4 class="tit">National IT Industry Promotion Agency</h4>
                        <p class="desc">2024 Small and Medium Business Cloud Service Supply and Diffusion Projec. In order to promote cloud-based digital transformation of domestic small and medium-sized businesses, the cost of introducing innovative
                            cloud services (usage fee, conversion
                            cost) and
                            Support for consulting, etc.</p>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide">
                        <div class="date">2021</div>
                        <h4 class="tit">Korea Radio Agency</h4>
                        <p class="desc">5G flagship project begins Non-face-to-face 5G realistic healing forest content for the post-corona era</p>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide">
                        <div class="date">2020</div>
                        <h4 class="tit">Korea Forestry Promotion Agency</h4>
                        <p class="desc">begins forest science and technology commercialization support project Blockchain, IoT, artificial intelligence convergence forest product quality certification system Research and development of forest product
                            quality certification system for ISP
                            and Clean Forest Food</p>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/css';
    import { Navigation } from 'swiper/modules';
    import 'swiper/css/navigation';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        data() {
            return {
                modules: [Navigation],
            };
        },
    };
</script>